import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  deleteFacility,
  fetchFacilities,
  updateFacility,
} from "../api/FacilityApi";
import {
  fetchDocumentsByOrganisationId,
  fetchDocumentById,
  uploadDocument,
  updateDocument,
  deleteDocument,
} from "../api/DocumentApi";
// import * as api from "../api/UserApi";

//--- get all facilities ---//
export const GetFacilities = () => {
  return useQuery("facilities", fetchFacilities);
};

//--- get all documents by ID ---//
export const GetDocumentByOrganisationId = (organisationId) => {
  const queryClient = useQueryClient();
  return useQuery(
    ["documents", organisationId],
    fetchDocumentsByOrganisationId,
    {
      enabled: !!organisationId,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000, // 5 minutes
      initialData: () => {
        const documents = queryClient
          .getQueryData(["documents", organisationId])
          ?.data;
        if (documents) {
          return {
            data: documents,
          };
        } else {
          return undefined;
        }
      },
    }
  );
};

//--- get document by ID ---//
export const GetDocumentById = (documentId) => {
  return useQuery(
    ["document", documentId],
    fetchDocumentById,
    {
      enabled: !!documentId,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000, // 5 minutes
    }
  );
};

//--- Upload document  ---//
export const UploadDocument = (options) => {
  const queryClient = useQueryClient();

  return useMutation((newDocument) => uploadDocument(newDocument), {
    onSuccess: (newDocument) => {
      console.log("Invalidating documents query...");
      queryClient.invalidateQueries(["documents"]);

      if (options?.onSuccess) options.onSuccess(newDocument);
    },
    onError: options?.onError,
  });
};

//--- Update document  ---//
export const UpdateDocument = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ documentId, documentData }) => updateDocument(documentId, documentData),
    {
      onSuccess: (data, variables) => {
        // Invalidate the specific document query
        queryClient.invalidateQueries(["document", variables.documentId]);
        // Invalidate all documents queries to refresh the list
        queryClient.invalidateQueries(["documents"]);
        if (options?.onSuccess) options.onSuccess();
      },
      onError: options?.onError,
    }
  );
};

//--- Delete document  ---//
export const DeleteDocument = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    (documentId) => deleteDocument(documentId),
    {
      onSuccess: (data, documentId) => {
        // Invalidate the specific document query
        queryClient.invalidateQueries(["document", documentId]);
        // Invalidate all documents queries to refresh the list
        queryClient.invalidateQueries(["documents"]);
        if (options?.onSuccess) options.onSuccess();
      },
      onError: options?.onError,
    }
  );
};

//--- Update facility ---//
export const UpdateFacility = (options) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ facilityId, facilityData }) => updateFacility(facilityId, facilityData),
    {
      onSuccess: () => {
        // Invalidate the facility query to ensure fresh data
        queryClient.invalidateQueries(["facilities"]);
        queryClient.invalidateQueries(["facility"]);
      },
      ...options, // Allow custom success/error handlers
    }
  );
};

export const DeleteFacility = (options) => {
  const queryClient = useQueryClient();

  return useMutation((facilityId) => deleteFacility(facilityId), {
    onSuccess: () => {
      queryClient.invalidateQueries(["facilities"]);
      queryClient.invalidateQueries(["facility"]);
    },
    ...options, // Spread custom handlers
  });
};
